import {
  View,
  Text,
  StyleSheet,
  // Image,
  TouchableOpacity,
  ActivityIndicator,
  Modal,
  Dimensions,
  PixelRatio,
  FlatList,
} from "react-native";
import React, { useEffect, useState } from "react";
import { Ionicons } from "@expo/vector-icons";

import Colours from "../../utils/Colours";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import ErrorAlertComp from "../../alertComp/ErrorAlertComp";

import { useQuery } from "@tanstack/react-query";
import { useNavigation } from "@react-navigation/native";
import { Image } from "expo-image";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const PlacesBid = () => {
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const navigation = useNavigation();
  const axiosPrivate = useAxiosPrivate();

  const getAllBrandsData = async () => {
    //console.log("this");
    const response = await axiosPrivate.get(`/allBrands/allBrands/`);
    //console.log("All Brands;", response.data);
    return response.data;
  };

  const {
    data: allBrands,
    isLoading: isLoading2,
    isError: isError2,
  } = useQuery({
    queryKey: ["allBrands"],
    queryFn: getAllBrandsData,
  });

  // return (
  //   <>
  //     {isLoading2 ? (
  //       <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
  //         <ActivityIndicator size={"large"} color={Colours.PRIMARY} />
  //       </View>
  //     ) : (
  //       <>
  //         <View style={styles.headerContainer}>
  //           <Text style={styles.headerTitle}>Top Locations</Text>
  //           <Text style={styles.headerSubtitle}>
  //             Join the bid to reserve a meeza table at the best hangout spots
  //           </Text>
  //         </View>

  //         <View style={{ paddingBottom: 20 }}>
  //           {allBrands && allBrands.length > 0
  //             ? allBrands.map((item, index) => {
  //                 // Safety check: if an element in the array is unexpected or blank, skip it safely
  //                 if (!item) return null;

  //                 return (
  //                   <TouchableOpacity
  //                     key={item._id || item.id || index}
  //                     style={styles.mainContainer}
  //                     onPress={() => {
  //                       navigation.navigate("howToSpend", {
  //                         listData: item,
  //                       });
  //                     }}
  //                   >
  //                     {/* TOP ROW */}
  //                     <View style={styles.celebratoryPullContainer}>
  //                       {/* LEFT — BRAND */}
  //                       <View style={styles.profileContainer}>
  //                         <Image
  //                           source={{ uri: item?.image }}
  //                           style={[styles.userImage, { backgroundColor: "#d6d4d4ff" }]}
  //                           contentFit="cover"
  //                         />

  //                         <View>
  //                           <Text
  //                             style={{
  //                               fontSize: dynamicFontSize(15),
  //                               width: dynamicSize(150),
  //                               color: Colours.DARKGRAY,
  //                               fontFamily: "Sen-Bold",
  //                               flexShrink: 1,
  //                             }}
  //                             numberOfLines={2}
  //                             ellipsizeMode="tail"
  //                           >
  //                             {item?.brandName}
  //                           </Text>
  //                           <Text
  //                             style={{
  //                               fontSize: dynamicFontSize(14),
  //                               color: Colours.DARKLIGHTGRAY,
  //                               fontFamily: "Sen-Regular",
  //                             }}
  //                           >
  //                             Location: {item?.brandAddress}
  //                           </Text>

  //                           <Text
  //                             style={{
  //                               fontSize: dynamicFontSize(13),
  //                               color: Colours.PRIMARY,
  //                               fontFamily: "Sen-Regular",
  //                             }}
  //                           >
  //                             Join the Bid
  //                           </Text>
  //                         </View>
  //                       </View>
  //                     </View>
  //                   </TouchableOpacity>
  //                 );
  //               })
  //             : null}
  //         </View>

  //         <Modal visible={isErrorCompVisible} transparent={true} animationType="fade">
  //           <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
  //         </Modal>
  //       </>
  //     )}
  //   </>
  // );

  return (
    <>
      {isLoading2 ? (
        <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
          <ActivityIndicator size={"large"} color={Colours.PRIMARY} />
        </View>
      ) : (
        <>
          <View style={styles.headerContainer}>
            <Text style={styles.headerTitle}>Top Locations</Text>
            <Text style={styles.headerSubtitle}>
              {/* Join the bid to reserve a meeza table at the best hangout spots */}
              The best and most active hangout spots
            </Text>
          </View>

          <View style={{ paddingBottom: 20 }}>
            {allBrands && allBrands.length > 0
              ? allBrands.map((item, index) => {
                  if (!item) return null;

                  return (
                    <TouchableOpacity
                      key={item._id || item.id || index}
                      style={styles.mainContainer}
                      activeOpacity={0.85}
                      onPress={() => {
                        navigation.navigate("howToSpend", {
                          listData: item,
                        });
                      }}
                    >
                      <View style={styles.celebratoryPullContainer}>
                        <View style={styles.profileContainer}>
                          {/* BRAND IMAGE */}
                          {/* <View style={styles.imageWrapper}>
                            <Image
                              source={{ uri: item?.image }}
                              style={[styles.userImage, { backgroundColor: "#f0f0f0" }]}
                              contentFit="cover"
                            />
                          </View> */}
                          <View style={styles.imageWrapper}>
                            <Image
                              // source={{ uri: item?.image }}
                              // style={{ width: "100%", height: "100%" }}
                              // contentFit="cover"
                              // borderRadius={dynamicSize(12)}
                              source={{ uri: item?.image }}
                              style={[styles.userImage, { backgroundColor: "#f0f0f0" }]}
                              contentFit="cover"
                            />
                          </View>
                          {/* CONTENT CONTAINER */}
                          <View style={styles.infoContentBlock}>
                            <Text
                              style={styles.brandTitleText}
                              numberOfLines={1}
                              ellipsizeMode="tail"
                            >
                              {item?.brandName}
                            </Text>

                            {/* LOCATION WITH ICON */}
                            <View style={styles.locationRow}>
                              <Ionicons
                                name="location-outline"
                                size={14}
                                color={Colours.DARKLIGHTGRAY}
                                style={{ marginRight: 4, marginTop: 1 }}
                              />
                              <Text
                                style={styles.locationDescriptionText}
                                numberOfLines={1}
                                ellipsizeMode="tail"
                              >
                                {item?.brandAddress}
                              </Text>
                            </View>

                            {/* ACTION CHIP */}
                            <View style={styles.actionChipContainer}>
                              <Text style={styles.actionChipText}>Join active tables</Text>
                              <Ionicons
                                name="trending-up"
                                size={12}
                                color={Colours.PRIMARY}
                                style={{ marginLeft: 4 }}
                              />
                            </View>
                          </View>
                        </View>

                        {/* CLASSIC CHEVRON UTILITY */}
                        <Ionicons
                          name="chevron-forward"
                          size={18}
                          color="#C7C7CC"
                          style={{ paddingRight: 4 }}
                        />
                      </View>
                    </TouchableOpacity>
                  );
                })
              : null}
          </View>

          <Modal visible={isErrorCompVisible} transparent={true} animationType="fade">
            <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
          </Modal>
        </>
      )}
    </>
  );
};

// const styles = StyleSheet.create({
//   mainContainer: {
//     display: "flex",
//     // alignItems: "center",
//     // marginTop: dynamicSpacing(15),
//     marginBottom: dynamicSpacing(15),

//     marginHorizontal: dynamicSpacing(0),
//     borderRadius: dynamicSize(15),
//     padding: dynamicSpacing(15),

//     backgroundColor: "white",
//   },

//   headerContainer: {
//     marginBottom: dynamicSpacing(15),
//   },

//   headerTitle: {
//     fontSize: dynamicFontSize(18),
//     fontFamily: "Sen-Bold",
//     color: Colours.PRIMARY,
//   },

//   headerSubtitle: {
//     fontSize: dynamicFontSize(13),
//     fontFamily: "Sen-Regular",
//     color: Colours.DARKLIGHTGRAY,
//     marginTop: dynamicSpacing(5),
//   },
//   horizontalDivider: {
//     height: dynamicSize(1),
//     // height: "70%",
//     backgroundColor: Colours.LIGHTGRAY,
//     marginVertical: dynamicSpacing(5),
//   },
//   textContainer: {
//     display: "flex",
//     flexDirection: "row",
//     gap: dynamicSpacing(10),
//   },
//   celebratoryPullContainer: {
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "center",

//     borderRadius: dynamicSize(15),
//     backgroundColor: "white",
//     shadowColor: "#E8E8E8",
//   },
//   TopText: {
//     display: "flex",
//     alignItems: "center",
//     justify: "center",
//     // paddingVertical: 15,
//   },
//   searchTxt: {
//     marginTop: dynamicSpacing(10),
//     marginBottom: dynamicSpacing(10),
//     fontSize: dynamicFontSize(16),
//     color: Colours.DARKLIGHTGRAY,
//     fontFamily: "Sen-Bold",
//   },
//   collumnTxt: {
//     paddingLeft: dynamicSpacing(1),
//     paddingBottom: 0,
//     color: Colours.PRIMARY,
//     fontFamily: "Sen-Regular",
//   },
//   usernameTxt: {
//     fontSize: dynamicFontSize(16),
//     color: Colours.DARKGRAY,
//     fontFamily: "Sen-Regular",
//   },
//   borderViewStyle: {
//     backgroundColor: Colours.DARKLIGHTGRAY,
//     height: dynamicSize(30),
//     width: dynamicSize(1),
//   },
//   userRealnameTxt: {
//     fontSize: dynamicFontSize(14),
//     color: Colours.DARKLIGHTGRAY,
//     fontFamily: "Sen-Regular",
//   },
//   moneyBouquetTxt: {
//     marginTop: dynamicSpacing(10),
//     marginBottom: dynamicSpacing(10),
//     fontSize: dynamicFontSize(14),
//     color: Colours.PRIMARY,
//     fontFamily: "Sen-Regular",
//     textAlign: "center",
//   },
//   borderSorrounding: {
//     display: "flex",
//     padding: dynamicSpacing(5),
//     borderRadius: dynamicSize(15),
//     borderWidth: dynamicSize(1),
//     borderColor: Colours.PRIMARY_LIGHTER,
//     backgroundColor: "white",
//     shadowColor: "#E8E8E8",
//   },
//   JoinedNumber: {
//     display: "flex",
//     flexDirection: "row",
//     alignItems: "center",
//     gap: dynamicSpacing(1),
//   },
//   inputTxt: {
//     height: dynamicSize(40),
//     width: dynamicSize(250),
//     marginTop: dynamicSpacing(10),
//     padding: dynamicSpacing(10),
//     borderWidth: dynamicSize(2.5),
//     borderColor: Colours.LIGHTGRAY,
//     borderRadius: dynamicSize(7),
//     fontFamily: "Sen-Regular",
//     fontSize: dynamicFontSize(15),
//     backgroundColor: Colours.LIGHTGRAY,
//     marginBottom: dynamicSpacing(10),
//     marginRight: dynamicSpacing(10),
//   },
//   searchBoxContainer: {
//     display: "flex",
//     flexDirection: "row",
//     alignItems: "center",
//   },
//   focusedBorder: {
//     borderColor: Colours.PRIMARY,
//     borderWidth: dynamicSize(2),
//   },
//   userImage: {
//     width: dynamicSize(70),
//     height: dynamicSize(70),
//     borderRadius: dynamicSize(99),
//   },
//   showImagePic: {
//     width: dynamicSize(85),
//     height: dynamicSize(70),
//     borderRadius: dynamicSize(15),
//   },
//   profileContainer: {
//     display: "flex",
//     flexDirection: "row",
//     alignItems: "center",
//     paddingTop: dynamicSpacing(10),
//     gap: dynamicSpacing(10),
//   },
// });

const styles = StyleSheet.create({
  mainContainer: {
    marginBottom: dynamicSpacing(14),
    marginHorizontal: dynamicSpacing(2), // Slight breathing room for shadows
    borderRadius: dynamicSize(16),
    padding: dynamicSpacing(12),
    backgroundColor: "white",

    // Premium Soft Drop Shadow
    shadowColor: "#000000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 8,
    elevation: 3,
  },
  imageWrapper: {
    width: dynamicSize(64),
    height: dynamicSize(64),
    borderRadius: dynamicSize(12),
    overflow: "hidden",
    backgroundColor: "#f0f0f0",
  },

  headerContainer: {
    // marginBottom: dynamicSpacing(20),
    paddingTop: dynamicSpacing(10),
    paddingHorizontal: dynamicSpacing(4),
  },

  headerTitle: {
    fontSize: dynamicFontSize(18), // Moderately emphasized premium scale
    fontFamily: "Sen-Bold",
    color: Colours.PRIMARY,
    letterSpacing: -0.3,
  },

  headerSubtitle: {
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
    color: Colours.DARKLIGHTGRAY,
    marginTop: dynamicSpacing(6),
    marginBottom: dynamicSpacing(6),
    lineHeight: dynamicFontSize(18),
  },

  celebratoryPullContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "white",
  },

  profileContainer: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },

  userImage: {
    width: dynamicSize(64),
    height: dynamicSize(64),
    borderRadius: dynamicSize(12), // Modern subtle squircle radius instead of perfect circle
    // overflow: "hidden",
  },

  infoContentBlock: {
    flex: 1,
    marginLeft: dynamicSpacing(14),
    justifyContent: "center",
  },

  brandTitleText: {
    fontSize: dynamicFontSize(16),
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Bold",
    marginBottom: dynamicSpacing(2),
  },

  locationRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: dynamicSpacing(6),
    paddingRight: dynamicSpacing(10),
  },

  locationDescriptionText: {
    fontSize: dynamicFontSize(13),
    color: Colours.DARKLIGHTGRAY,
    fontFamily: "Sen-Regular",
    flex: 1,
  },

  actionChipContainer: {
    flexDirection: "row",
    alignItems: "center",
    alignSelf: "flex-start",
    backgroundColor: `${Colours.PRIMARY}10`, // Adds a sleek 10% opacity tint background match
    paddingHorizontal: dynamicSpacing(8),
    paddingVertical: dynamicSpacing(3),
    borderRadius: dynamicSize(6),
  },

  actionChipText: {
    fontSize: dynamicFontSize(11),
    color: Colours.PRIMARY,
    fontFamily: "Sen-Bold",
    textTransform: "uppercase",
    letterSpacing: 0.4,
  },

  // Keep rest of your legacy styles intact below if used elsewhere...
});

export default PlacesBid;
